import { getFileExtensionFromFileName } from "../../../shared/utils/getFileExtensionFromFileName";

export const ASSESSMENT_ACCEPTED_EXTENSIONS = ["pdf", "doc", "docx"];
export const ASSESSMENT_MAX_FILE_SIZE_BYTES = 30 * 1024 * 1024;

export const validateAssessmentFile = (file) => {
  const extension = getFileExtensionFromFileName(file.name);

  if (!ASSESSMENT_ACCEPTED_EXTENSIONS.includes(extension)) {
    return { valid: false, reason: "invalid-type" };
  }

  if (file.size > ASSESSMENT_MAX_FILE_SIZE_BYTES) {
    return { valid: false, reason: "invalid-size" };
  }

  return { valid: true };
};

// Derives the "O parecer vai ser relacionado ao ..." label from the attachments currently selected in CultureHubModal
export const getAssessmentRelationLabel = (selectedIds = [], groups = []) => {
  const selectedAttachments = groups.flatMap((group) =>
    group.sections.flatMap((section) =>
      section.attachments
        .filter((attachment) => selectedIds.includes(attachment.id))
        .map((attachment) => ({
          ...attachment,
          blockNumber: section.blockNumber,
        }))
    )
  );

  if (selectedAttachments.length === 0) {
    return "";
  }

  if (selectedAttachments.length === 1) {
    const [attachment] = selectedAttachments;

    return attachment.number != null
      ? `Capítulo ${String(attachment.number).padStart(2, "0")} - v${
          attachment.version
        }`
      : attachment.fileName;
  }

  // only collapse to "Bloco X" when every selected item belongs to that same block;
  // a single non-block item (e.g. "Outros anexos") mixed in must not be silently ignored
  const [firstAttachment] = selectedAttachments;
  const allSameBlock =
    firstAttachment.blockNumber != null &&
    selectedAttachments.every(
      (attachment) => attachment.blockNumber === firstAttachment.blockNumber
    );

  if (allSameBlock) {
    return `Bloco ${String(firstAttachment.blockNumber).padStart(2, "0")}`;
  }

  return `${selectedAttachments.length} itens selecionados`;
};

// "itens selecionados" is plural, so the "relacionado ao ..." phrase needs "aos" instead of "ao"
export const getAssessmentRelationPreposition = (relationLabel) =>
  relationLabel.endsWith("itens selecionados") ? "aos" : "ao";
